export default __webpack_public_path__ + "static/media/jibowu-terminal.017b5862.png";